export const AUTOMATED_SORTATION_CENTERS = ["SC_TST_3", "SC_ATL_1", "SC_EWR_1", "SC_TST_4", "SC_LAX_1"];
